export default __webpack_public_path__ + "static/media/orderBasket.c31e88c6.svg";